<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'question-sorting'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <legend>Question Sorting</legend>

      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="question-sorting-topics" class="form-label">Topics</label>
          <ng-select
            id="question-sorting-topics"
            name="questionSortingTopics"
            placeholder="All Topics"
            [multiple]="true"
            [searchable]="true"
            [clearable]="true"
            [closeOnSelect]="false"
            [disabled]="isSaving || hasChanges"
            [(ngModel)]="selectedTopicIds"
            (ngModelChange)="onFiltersChanged()">
            @for (topic of topics; track topic.id) {
              <ng-option [value]="topic.id">{{topic.name}}</ng-option>
            }
          </ng-select>
        </div>

        <div class="col-md-6 mb-3">
          <label for="question-sorting-standards" class="form-label">Standards</label>
          <ng-select
            id="question-sorting-standards"
            name="questionSortingStandards"
            placeholder="All Standards"
            [multiple]="true"
            [searchable]="true"
            [clearable]="true"
            [closeOnSelect]="false"
            [disabled]="isSaving || hasChanges"
            [(ngModel)]="selectedStandardIds"
            (ngModelChange)="onFiltersChanged()">
            @for (standard of standards; track standard.id) {
              <ng-option [value]="standard.id">{{standard.name}}</ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-primary mr-2" (click)="saveChanges()" [disabled]="!hasChanges || isSaving">
          <i class="fa fa-save"></i>
          Save Changes
        </button>
        <button type="button" class="btn btn-secondary" (click)="cancelChanges()" [disabled]="!hasChanges || isSaving">
          <i class="fa fa-ban"></i>
          Cancel
        </button>
      </div>

      @if (isLoading) {
        <div class="question-sorting-empty">Loading Questions&hellip;</div>
      } @else if (tree.length === 0) {
        <div class="question-sorting-empty">No Questions match the selected Topics or Standards.</div>
      } @else {
        <div class="question-sorting-tree">
          @for (topic of tree; track topic.topicId) {
            <section class="question-sorting-topic">
              <button
                type="button"
                class="question-sorting-topic-header"
                [attr.aria-expanded]="!isTopicCollapsed(topic.topicId)"
                (click)="toggleTopic(topic.topicId)">
                <i class="fa" [class.fa-chevron-right]="isTopicCollapsed(topic.topicId)" [class.fa-chevron-down]="!isTopicCollapsed(topic.topicId)"></i>
                <strong>{{topic.topicName}}</strong>
              </button>

              @if (!isTopicCollapsed(topic.topicId)) {
                <div class="question-sorting-sublist">
                  @if (hasRootQuestions(topic)) {
                    <div class="question-sorting-group">
                      <button
                        type="button"
                        class="question-sorting-group-header"
                        [attr.aria-expanded]="!isRootQuestionsCollapsed(topic.topicId)"
                        (click)="toggleRootQuestions(topic.topicId)">
                        <i class="fa" [class.fa-chevron-right]="isRootQuestionsCollapsed(topic.topicId)" [class.fa-chevron-down]="!isRootQuestionsCollapsed(topic.topicId)"></i>
                        <span>{{topic.topicName}}</span>
                      </button>
                      @if (!isRootQuestionsCollapsed(topic.topicId)) {
                        <div
                          cdkDropList
                          class="question-sorting-list"
                          [cdkDropListData]="topic.rootQuestions"
                          (cdkDropListDropped)="dropRootQuestion($event, topic)">
                          @for (question of topic.rootQuestions; track question.questionId; let i = $index) {
                            <div cdkDrag class="question-sorting-item">
                              <button type="button" cdkDragHandle class="question-sorting-drag-handle" aria-label="Move Question">
                                <i class="fa fa-bars"></i>
                              </button>
                              <span class="question-sorting-order">{{i + 1}}</span>
                              <span
                                class="question-sorting-question-code"
                                [ngbTooltip]="question.questionText"
                                [attr.aria-label]="question.questionCode + ': ' + question.questionText">
                                {{question.questionCode}}
                              </span>
                              </div>
                          }
                        </div>
                      }
                    </div>
                  }

                  <div
                    cdkDropList
                    class="question-sorting-standard-list"
                    [cdkDropListData]="topic.standards"
                    (cdkDropListDropped)="dropStandard($event, topic)">
                    @for (standard of topic.standards; track standard.standardId) {
                      <div cdkDrag class="question-sorting-group">
                        <div class="question-sorting-standard-row">
                          <button type="button" cdkDragHandle class="question-sorting-drag-handle" aria-label="Move Standard">
                            <i class="fa fa-bars"></i>
                          </button>
                          <button
                            type="button"
                            class="question-sorting-group-header"
                            [attr.aria-expanded]="!isStandardCollapsed(topic.topicId, standard.standardId)"
                            (click)="toggleStandard(topic.topicId, standard.standardId)">
                            <i class="fa" [class.fa-chevron-right]="isStandardCollapsed(topic.topicId, standard.standardId)" [class.fa-chevron-down]="!isStandardCollapsed(topic.topicId, standard.standardId)"></i>
                            <span>{{standard.standardName}}</span>
                          </button>
                        </div>
                        @if (!isStandardCollapsed(topic.topicId, standard.standardId)) {
                          @if (standard.questions.length === 0) {
                            <div class="question-sorting-empty nested">No questions in this Standard.</div>
                          } @else {
                            <div
                              cdkDropList
                              class="question-sorting-list"
                              [cdkDropListData]="standard.questions"
                              (cdkDropListDropped)="dropStandardQuestion($event, standard)">
                              @for (question of standard.questions; track question.questionId; let i = $index) {
                                <div cdkDrag class="question-sorting-item">
                                  <button type="button" cdkDragHandle class="question-sorting-drag-handle" aria-label="Move Question">
                                    <i class="fa fa-bars"></i>
                                  </button>
                                  <span class="question-sorting-order">{{i + 1}}</span>
                                  <span
                                    class="question-sorting-question-code"
                                    [ngbTooltip]="question.questionText"
                                    [attr.aria-label]="question.questionCode + ': ' + question.questionText">
                                    {{question.questionCode}}
                                  </span>
                                </div>
                              }
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </section>
          }
        </div>
      }
    </fieldset>
  </div>
</div>
